import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import VideoService from '@/services/VideoService';
import VideoList from '@/components/video-list/List';
import UserService from '@/services/UserService';
import Livestream from '@/components/schedule/Livestream';
import LivestreamService from '@/services/LivestreamService';
import SearchChips from '@/components/video-list/SearchChips';
import { bus } from '@/eventBus';
export default {
  name: 'VideoSearch',
  props: {
    id: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      searchTerms: [],
      pagination: {
        numPages: 1,
        page: 1,
        perPage: 20,
        rows: 1
      },
      channel_id: null,
      loading: false,
      channels: [],
      videos: [],
      display: 0,
      currentTab: 0,
      liveCount: 0
    };
  },
  computed: {
    allTabs() {
      const liveTab = {
        key: 'live',
        id: 'live',
        title: 'Live Now',
        iconClass: 'broadcast',
        totalResults: this.liveCount
      };
      const tabs = this.videos || [];
      const favoriteTabs = tabs.filter(t => String(t.title || '').toLowerCase().includes('favorite'));
      const regularTabs = tabs.filter(t => !String(t.title || '').toLowerCase().includes('favorite'));
      return [...regularTabs, liveTab, ...favoriteTabs];
    },
    isLiveTab() {
      const active = this.allTabs[this.currentTab];
      return active && active.key === 'live';
    },
    activeVideoTab() {
      if (this.isLiveTab) return null;
      return this.allTabs[this.currentTab] || null;
    },
    currentChannelName() {
      const id = Number(this.channel_id);
      const channel = (this.channels || []).find(c => Number(c.id) === id);
      return channel && channel.name ? channel.name : '';
    }
  },
  mounted() {
    this.init();
    bus.$on('videoFavoriteUpdated', ({
      id,
      favorite
    }) => {
      this.updateVideoFavoriteStatus({
        id,
        favorite,
        video: {
          id
        }
      });
    });
  },
  beforeUnmount() {
    bus.$off('videoFavoriteUpdated');
  },
  methods: {
    init() {
      this.loading = true;
      this.channel_id = this.id;
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      this.searchTerms = String(params.get('text_search') || '').split(/[\s,]+/).map(t => t.trim()).filter(t => t.length);
      setTimeout(() => {
        this.getVideos();
      }, 1);
      this.preloadLiveCount();
      UserService.getNetworkInfo().then(network => {
        this.channels = network.channels;
      });
    },
    getDefaultTabIndex() {
      const requestedTab = this.$route.query.tab;
      if (requestedTab === 'live') {
        const liveIndex = this.allTabs.findIndex(t => t.key === 'live');
        return liveIndex !== -1 ? liveIndex : 0;
      }
      const firstOnDemandIndex = this.allTabs.findIndex(t => t.key !== 'live');
      return firstOnDemandIndex !== -1 ? firstOnDemandIndex : 0;
    },
    preloadLiveCount() {
      const data = {
        scheduletype: 1
      };
      if (this.channel_id) {
        data.channel_id = this.channel_id;
      }
      LivestreamService.getSchedule(data).then(response => {
        let results = response.data.results || [];
        results = results.filter(stream => +stream.islive === 1);
        this.liveCount = results.length;
      }).catch(() => {
        this.liveCount = 0;
      });
    },
    setLiveCount(count) {
      this.liveCount = count;
    },
    showVideo(id) {
      bus.$emit('clearVideo');
      VideoService.fetch(id).then(response => {
        bus.$emit('videoSelected', response.data);
      }).catch(err => {
        this.$aim.notify(err.response);
      });
    },
    getVideos(list = null) {
      this.loading = true;
      const adjustedList = list !== null ? this.videos.findIndex(v => v.id === (this.allTabs[list] && this.allTabs[list].id)) : null;
      const pag = adjustedList !== null ? this.videos[adjustedList] && this.videos[adjustedList].pagination ? this.videos[adjustedList].pagination : this.pagination : this.pagination;
      const data = {
        filters: {},
        pagination: pag,
        list: adjustedList
      };
      if (this.searchTerms.length) {
        data.filters.text_search = this.searchTerms;
      }
      if (this.channel_id) {
        data.filters.channel_id = this.channel_id;
        VideoService.channelVideos(data).then(response => {
          if (adjustedList !== null) {
            this.videos[adjustedList] = response.data.videos;
          } else {
            this.videos = response.data.videos;
            this.currentTab = this.getDefaultTabIndex();
          }
        }).catch(error => {
          this.$aim.error(error.response);
        }).finally(() => {
          this.loading = false;
        });
      } else {
        VideoService.search(data).then(response => {
          this.videos = [response.data];
          this.currentTab = this.getDefaultTabIndex();
        }).catch(error => {
          this.$aim.error(error.response || {
            data: {
              error: [error.message]
            }
          });
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    updateVideoFavoriteStatus({
      id,
      favorite,
      video
    }) {
      this.videos.forEach(tab => {
        if (Array.isArray(tab.results)) {
          tab.results.forEach(item => {
            if (item.id === id) item.favorite = favorite;
          });
        }
      });
      const favTabIndex = this.videos.findIndex(t => String(t.title || '').toLowerCase().includes('favorite'));
      if (favTabIndex === -1) return;
      const favTab = this.videos[favTabIndex];
      if (!Array.isArray(favTab.results)) {
        favTab.results = [];
      }
      if (favorite) {
        if (!favTab.results.find(x => x.id === id)) {
          favTab.results.unshift({
            ...video
          });
          favTab.totalResults = (favTab.totalResults || 0) + 1;
        }
      } else {
        const i = favTab.results.findIndex(x => x.id === id);
        if (i !== -1) {
          favTab.results.splice(i, 1);
          favTab.totalResults = Math.max(0, (favTab.totalResults || 1) - 1);
        }
      }
    },
    updatePage(event) {
      if (this.isLiveTab || !this.activeVideoTab) return;
      this.activeVideoTab.pagination.page = event;
      this.getVideos(this.currentTab);
    }
  },
  components: {
    VideoList,
    Livestream,
    SearchChips
  },
  watch: {
    id: function (n, o) {
      if (o !== n) {
        this.channel_id = n;
        this.currentTab = 0;
        this.liveCount = 0;
        this.init();
      }
    }
  }
};